import './App.css';
import VMR from "./VMR";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <VMR />
      </header>
    </div>
  );
}

export default App;
